import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { apiClient } from "../lib/api";

export function useProjects() {
  return useQuery({
    queryKey: ["projects"],
    queryFn: async () => (await apiClient.get("/projects")).data,
  });
}

export function useDraftProject() {
  return useMutation({
    mutationFn: async ({ name, driveFolder }) => {
      const { data } = await apiClient.post("/projects/draft", {
        name,
        drive_folder: driveFolder || null,
      });
      return data;
    },
  });
}

export function useCreateProject() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async ({ name, driveFolder, description, systemPrompt }) => {
      const { data } = await apiClient.post("/projects", {
        name,
        drive_folder: driveFolder || null,
        description,
        system_prompt: systemPrompt,
      });
      return data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["projects"] });
    },
  });
}

// Proyecto NUEVO desde cero (taller): crea su carpeta de Drive con la estructura estándar y deja pendiente el servidor del taller.
export function useCreateBlankProject() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async ({ name, goal }) => {
      const { data } = await apiClient.post("/projects/blank", { name, goal });
      return data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["projects"] });
    },
  });
}

export function useUpdateProject() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async ({ id, ...updates }) => {
      const { data } = await apiClient.patch(`/projects/${id}`, updates);
      return data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["projects"] });
    },
  });
}

// El agente general («🧠 Orquestador»): su chat principal y el último intercambio, para el inicio.
export function useGeneral() {
  return useQuery({
    queryKey: ["general"],
    queryFn: async () => (await apiClient.get("/general")).data,
    staleTime: 0,
    retry: false,
  });
}
